module.exports = __webpack_public_path__ + "media/images/icon_rank_02-1f68026013db0acdb641c8c42226a925.png";